import { useFormContext } from '@calendly/form'
import { useCallback, useEffect, useRef } from 'react'

export const useSetValuesAndSubmit = ({ withSubmit = false }) => {
  const shouldSubmit = useRef(false)
  const { dirty, setValues, submitForm } = useFormContext()

  useEffect(() => {
    const handleSubmit = () => {
      if (shouldSubmit.current && dirty) {
        submitForm()
        shouldSubmit.current = false
      }
    }

    handleSubmit()

    return handleSubmit
  }, [dirty, submitForm])

  const setValuesAndSubmit = useCallback((values) => {
    shouldSubmit.current = true
    setValues(values)
  }, [setValues])

  return withSubmit ? setValuesAndSubmit : setValues
}
